"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeListItem = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../Text/index.js");
var _logging = require("../../logging.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var _utils = require("../../utils.js");
var _excluded = ["as", "listStyleReset", "condensed", "variant", "weight"];
var TypeListItemElement = (0, _styledComponents["default"])(_index.Text).withConfig({
  displayName: "TypeListItem__TypeListItemElement",
  componentId: "sc-q1l2mf-0"
})(["display:list-item;padding-block-end:", ";", ";"], function (props) {
  return !props.$condensed && '1em';
}, function (props) {
  return props.$listStyleReset && "list-style-type: none";
});

/**
 * TypeListItem is an individual unit in the TypeList component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-typelist-typelistitem--docs) |
 * [Encore site](https://encore.spotify.net/web/components/text#text-lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeListItem)
 */
var TypeListItem = exports.TypeListItem = /*#__PURE__*/_react["default"].forwardRef(function TypeListItem(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'li' : _ref$as,
    _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    condensed = _ref.condensed,
    variant = _ref.variant,
    weight = _ref.weight,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  if (variant) (0, _logging.warnLegacyTypeVariant)('TypeListItem', variant, weight);
  return /*#__PURE__*/_react["default"].createElement(TypeListItemElement, Object.assign({}, props, {
    ref: ref,
    forwardedAs: as,
    variant: variant && (0, _utils.mapLegacyToTextVariant)(variant, weight),
    $condensed: condensed,
    $listStyleReset: listStyleReset,
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.TypeListItem
  }));
});